<template>
    <div>
        <el-dropdown placement="bottom-start" @command="handleCommand">
            <el-button style="margin-right: 20px;" size="small" type="menu" icon="el-icon-edit-outline">{{$t('settings_payXoft_timeKeeping_schedules_addSchedule')}}</el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="normalDay" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_payXoft_timeKeeping_normal')}}</el-dropdown-item>
                <el-dropdown-item command="flexy" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_payXoft_timeKeeping_flexi')}}</el-dropdown-item>
                <el-dropdown-item command="rotated" class="nav-tree__item" size="mini" type="primary" plain>{{$t('settings_payXoft_timeKeeping_rotations')}}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
        <!--<div>-->
            <!--<el-button @click="openModalAdd" class="nav-tree__item" size="mini" type="primary" plain icon="el-icon-plus">{{$t('settings_payXoft_timeKeeping_schedules_addSchedule')}}</el-button>-->
        <!--</div>-->
        <el-tabs :value="value" @input="(val) => $emit('input', val)" @tab-click="handleClick">
            <el-tab-pane :label="$t('settings_payXoft_timeKeeping_normal')" name="schedules">

            </el-tab-pane>

            <el-tab-pane :label="$t('settings_payXoft_timeKeeping_flexi')" name="flexi">
                Current Service Under Development
            </el-tab-pane>

            <el-tab-pane :label="$t('settings_payXoft_timeKeeping_rotations')" name="rotations">
                Current Service Under Development
            </el-tab-pane>
        </el-tabs>
        <add-schedule-modal ref="addScheduleModalComponent" @loadList="loadList"/>
    </div>
</template>

<script>
  import AddScheduleModal from "./AddScheduleModal";
  export default {
    name: "TimeKeepingTab",
    components: {AddScheduleModal},
    props:['value'],
    methods: {
      handleCommand(command) {
        switch (command) {
          case 'normalDay':
            this.$refs.addScheduleModalComponent.open();
            break;
        }
      },
      handleClick(tab){

      },
      openModalAdd(){

      },
      loadList(){
        console.log('load list')
      }
    }
  }
</script>

<style scoped>

</style>
